import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FiXCircle, FiArrowLeft, FiLoader, FiRefreshCw } from "react-icons/fi";
import { verifyInvoicesById } from '../../ApiController/ApiService'; 

const PaymentFailed = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const invoiceId = searchParams.get('id');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const updateFailedStatus = async () => {
            if (!invoiceId) {
                setLoading(false);
                return;
            }

            try {
                await verifyInvoicesById(invoiceId,{status:"failed"});
            } catch (error) {
                console.error('Failed to update status:', error);
            } finally {
                setLoading(false);
            }
        };

        updateFailedStatus();
    }, [invoiceId]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#080625] text-white p-4">
            <div 
                className="max-w-md w-full p-8 rounded-2xl shadow-2xl text-center relative overflow-hidden border border-[#1E2A60]"
                style={{
                    background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                    backdropFilter: 'blur(42.7px)'
                }}
            >
                {loading ? (
                    <div className="flex flex-col items-center justify-center py-10">
                        <FiLoader className="text-red-500 text-5xl animate-spin mb-4" />
                        <h2 className="text-xl font-semibold mb-2">Updating Status...</h2>
                        <p className="text-gray-400 text-sm">Please wait a moment.</p>
                    </div>
                ) : (
                    <div className="flex flex-col items-center py-6 animate-fade-in">
                        <div className="w-24 h-24 rounded-full bg-red-500/10 flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(239,68,68,0.2)]">
                            <FiXCircle className="text-red-500 text-[60px]" />
                        </div>
                        
                        <h2 style={{ fontFamily: "Poppins" }} className="text-2xl sm:text-[30px] font-bold text-white leading-tight mb-2">
                            Payment <span className="text-red-500">Failed!</span>
                        </h2>
                        
                        <p className="text-sm text-gray-400 mb-6 px-2">
                            We couldn't process your payment. It looks like the transaction was cancelled or declined.
                        </p>
                        
                        <div className="bg-[#10194E] w-full rounded-lg p-4 mb-8 border border-red-500/30 text-left">
                            <p className="text-xs text-gray-400 mb-1">Invoice ID</p>
                            <p className="font-semibold text-sm text-red-400">{invoiceId || 'N/A'}</p>
                        </div>

                        <div className="flex flex-col gap-3 w-full">
                            <button
                                onClick={() => navigate('/dashboard')} 
                                className="flex items-center justify-center gap-2 w-full py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 transition font-medium text-sm shadow-md"
                            >
                                <FiRefreshCw />
                                Try Again
                            </button>

                            <button
                                onClick={() => navigate('/dashboard')} // Dashboard par wapas jaane ke liye
                                className="flex items-center justify-center gap-2 w-full py-3 bg-transparent border border-[#1E2A60] text-gray-300 rounded-xl hover:bg-[#10194E] transition font-medium text-sm"
                            >
                                <FiArrowLeft />
                                Back to Dashboard
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentFailed;